module.exports = __webpack_public_path__ + "img/t4-feature-image.5e3fb227.png";